import type {
  CoachingPartnership,
  CoachProfile,
} from '@efdigital/ll-addon-data';
import { queryCoachProfileByUserId } from '@efdigital/ll-xceed-v2/data/builders/coaching/coach-profiles';
import type CoacheeService from '@efdigital/ll-xceed-v2/services/coachee';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type { Store } from '@warp-drive/core';

import type { CoachingCoacheeCohortModel } from '../../cohort';

export type CoachingCoacheeCohortCoachesCoachPathParams = {
  coach_id: string;
};

export type CoachingCoacheeCohortCoachesCoachModel =
  CoachingCoacheeCohortModel &
    CoachingCoacheeCohortCoachesCoachPathParams & {
      coach: CoachProfile;
      /** Set when this coach is one the coachee can message. */
      messagePartnership?: CoachingPartnership;
    };

export default class CoachingCoacheeCohortCoachesCoachRoute extends Route<CoachingCoacheeCohortCoachesCoachModel> {
  @service declare coachee: CoacheeService;
  @service declare store: Store;

  async model(
    params: CoachingCoacheeCohortCoachesCoachPathParams
  ): Promise<CoachingCoacheeCohortCoachesCoachModel> {
    const coaches = await this.store.request(
      queryCoachProfileByUserId(params.coach_id, 'published')
    );
    const coach = coaches.content.data.find((c) => c.user === params.coach_id);

    if (!coach) {
      throw new Error('Coach not found');
    }

    const cohortModel = this.modelFor(
      'coaching.coachee.cohort.coaches'
    ) as CoachingCoacheeCohortModel;

    return {
      ...cohortModel,
      ...params,
      coach,
      messagePartnership: cohortModel.planner.messagingPartnerships.find(
        (partnership) => partnership.coachUserId === params.coach_id
      ),
      isCoachee: await this.coachee.isCoachee(),
    };
  }
}
